import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { storageService } from 'js/services/storage.service';
import { useAppSelector, useCookieSettingsSelector } from 'js/store/hooks';
import { setCookiesGroupsInitial } from 'js/components/main/CookieSettings/store/actions';

import * as helpers from '../../helpers';

export const useSetInitialCookiesGroups = () => {
    const dispatch = useDispatch();
    const { cookieGroups } = useAppSelector(prop('cookiesConfiguration'));
    const storageCookieName = useCookieSettingsSelector(prop('storageCookieName'));
    const { search } = useLocation();

    useEffectOnce(() => {
        const defaultCookiesGroups = helpers.parseCookiesGroups(cookieGroups);
        const searchParametersGroups = helpers.parseSearchParametersGroups(cookieGroups, search);
        const storageCookiesGroups = storageService.local.getItem(storageCookieName) || {};
        const mergedStorageGroups = helpers.prepareCookiesGroups(defaultCookiesGroups, storageCookiesGroups);
        const mergedGroups = helpers.prepareCookiesGroups(mergedStorageGroups, searchParametersGroups);

        storageService.local.setItem(storageCookieName, mergedGroups);
        dispatch(setCookiesGroupsInitial(mergedGroups));
    }, [search, dispatch, cookieGroups, storageCookieName]);
};
